export default "__VITE_ASSET__a2c9f3ef__"